var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 5.333h-.666V4a3.335 3.335 0 0 0-6.667 0v1.333H4c-.733 0-1.333.6-1.333 1.333v6.667c0 .733.6 1.333 1.333 1.333h8c.734 0 1.334-.6 1.334-1.333V6.666c0-.733-.6-1.333-1.334-1.333ZM6 4c0-1.107.894-2 2-2 1.107 0 2 .893 2 2v1.333H6V4Zm6 9.333H4V6.666h8v6.667Zm-4-2c.734 0 1.334-.6 1.334-1.333S8.734 8.666 8 8.666c-.733 0-1.333.6-1.333 1.334 0 .733.6 1.333 1.333 1.333Z",
  fill: "currentColor"
})));

export default SvgLock;